import { useEffect } from "react"

interface TrackOptions {
  page: string
  slug?: string
}

export function useTrackPageView({ page, slug }: TrackOptions) {
  useEffect(() => {
    fetch("/api/track-view", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page, slug }),
      keepalive: true,
    }).catch(() => {})
  }, [page, slug])
}
